<div class="copyright-footer" [style.top.px]="top">
	<div class="footer-logo">
		<img src="assets/images/ehe_pulse_logo.svg" alt="EHE Health" class="footer-logo-text" />
	</div>
	<div class="footer-content">
		<span class="copyright-text">&copy; {{ currentYear }} EHE. All rights reserved.</span>
		<span class="link-separator">|</span>
		<a [routerLink]="['/terms']" class="footer-link">Terms and Conditions</a>
		<span class="link-separator">|</span>
		<a [routerLink]="['/privacy-policy']" class="footer-link">Data Privacy Policy</a>
		<span class="link-separator">|</span>
		<a [routerLink]="['/notice-of-privacy-practices']" class="footer-link">Notice of Privacy Practices</a>
		<span class="link-separator">|</span>
		<a (click)="openCookiesPreferences($event)" class="footer-link">Cookie Preferences</a>
	</div>
</div>
